export default "/_next/static/c4a1b8715600682bf2db429e9176d6bd.png";